import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-xl bg-gradient shadow-lg shadow-black/80 border border-border",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
